<div class="forgot-password"
     [formGroup]="form">
  <mat-form-field id="username"
                  appearance="outline">
    <mat-label>Username</mat-label>
    <input matInput
           type="text"
           id="txtUserName"
           autocomplete="username"
           formControlName="username"
           name="Username"
           autofocus
           required>
    <mat-error>
      @if (form.controls.username.hasError('required')) {
        Username is required
      }
    </mat-error>
  </mat-form-field>

  @if (recaptchaPublicKey.length > 0)
  {
    <div class="g-recaptcha"
         [attr.data-sitekey]="recaptchaPublicKey">
    </div>
  }

  @if (errorMessage)
  {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>
      <span class="error-text">{{ errorMessage }}</span>
    </div>
  }

  <div class="actions">
    <a [href]="loginUrl"
       mat-button>
      Back to login
    </a>

    <button type="submit"
            id="buton-reset-password"
            mat-flat-button>
      Reset password
    </button>
  </div>
</div>
